import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getCommonApi, commonCreateApi } from "redux/actions/common";
import { withTranslation } from "react-i18next";
import { NormalTable } from "component/common";
import print from "assets/images/reports/print.png";

export class PrintTreatmentReportsClass extends Component {
  state = {
    formFields: {
      projectTitle: "",
      projectDesc: "",
      status: "",
      custName: "",
      contactName: "",
      contactNumber: "",
    },
    SiteSelectionOption: [],
    SiteSelection: [],
    from_Date: new Date(),
    to_Date: new Date(),
    reports: [],
    ReportTable: [],
    projectList: [],

    statusOption: [],
    hide: true,
    is_loading: true,
    isPrintPdfClick: false,
    isMounted: true,
    treatmentListHeader: [
      // {
      //   label: "Issued by",
      //   className: " align-items-center justify-content-center",
      // },
      // {
      //   label: "Invoice Ref",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Customer",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Customer Ref.",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Payment by others",
      //   className: " align-items-center justify-content-center",
      // },
      // {
      //   label: "TAXES",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Bank charges",
      //   className: "align-items-center justify-content-center",
      // },
      // {
      //   label: "Receivables",
      //   className: "align-items-center justify-content-center",
      // },
    ],
    active: false,
    currentValue: 0,
    CollectionOutlet: [],
    perPage: 10,
    currentPage: 1,
    navLinks: [
      {
        to: this.props.location.pathname,
        label: "Activities",
        id: "Activities",
      },
      {
        to: this.props.location.pathname,
        label: "Quotation",
        id: "Quotation",
      },
      { to: this.props.location.pathname, label: "Purchase Order", id: "PO" },
    ],
    selectedMenu: "Activities",
    PayModeOption: [],
    PayMode: [],
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };
  componentDidMount() {
    // this.handleViewReport();
    console.log(this.props.location?.state?.CollectionOutlet, "nivy");
    console.log(this.props?.location.state?.paymentTransactions, "nib");
  }
  Print = () => {
    let printContents = document.getElementById("printablediv");
    this.setState({ showPrint: false });
    window.print();
  };
  render() {
    const payment = this.props?.location.state?.paymentTransactions;
    const headerDetails = this.props.location?.state?.CollectionOutlet;
    const date = this.props?.location.state?.payDate;
    let { ReportTable, CollectionOutlet } = this.state;
    const groupedTransactions = payment.reduce((groups, transaction) => {
      const { payTypes } = transaction;
      groups[payTypes] = groups[payTypes] || [];
      groups[payTypes].push(transaction);
      return groups;
    }, {});
    return (
      <div>
        {" "}
        <div>
          <div className="row bg-white m-5">
            <div className="col-12">
              <div className="p-3 m-3" id="printablediv">
                <div className="row">
                  <div className="col-md-6 ">
                    <h3 className="reports-heading my-5">
                      {headerDetails.title}
                      <span className="mx-2">|</span>
                      <span className="mx-2">{headerDetails.comp_title3} </span>
                      <span className="mx-2">|</span>
                      {headerDetails.comp_title4}
                      <span className="mx-2">|</span>
                    </h3>
                  </div>
                  <div className="col-md-6 mt-5 text-right">
                    {" "}
                    <button
                      className="pointer border bg-white col-4 p-2"
                      onClick={() => this.Print()}
                    >
                      <img src={print} alt="print" className="mx-3" />
                      Print
                    </button>
                  </div>
                </div>

                <div className="table-container table-responsive ">
                  {/* {Object.entries(groupedTransactions).length > 0 ? ( */}
                  {Object.entries(groupedTransactions)?.map(
                    ([payType, transactions]) => {
                      return (
                        <>
                          {console.log(transactions, "groupedtransact")}

                          <NormalTable
                            headerDetails={this.state.treatmentListHeader}
                          >
                            <thead>
                              <tr>
                                {/* {this.state.treatmentListHeader.map((e) => {
                        return (
                          <th className="align-items-center justify-content-center">
                            {e.label}
                          </th>
                        );
                      })} */}

                                {/* <th className="align-items-center justify-content-center">
                          Payment type
                        </th>
                        <th className="align-items-center justify-content-center">
                          Payment date
                        </th> */}
                                <th className="align-items-center justify-content-center">
                                  STAFF NAME
                                </th>
                                <th className="align-items-center justify-content-center">
                                  CUSTOMER
                                </th>
                                <th className="align-items-center justify-content-center">
                                  S.NO
                                </th>
                                <th className="align-items-center justify-content-center">
                                  DATE
                                </th>
                                <th className="text-center">SALES TRANS</th>
                                <th className="text-center">#TD TRANS</th>
                                <th className="text-center">ITEM NAME</th>
                                <th className="text-center">UNIT VALUE</th>
                                <th className="text-center">SHARE AMOUNT</th>
                                <th className="text-center">WORK POINT</th>
                                <th className="text-center">DURATION</th>
                              </tr>
                            </thead>
                            <div key={payType}>
                              {payment.map((transaction, index) => {
                                return (
                                  <tr className="w-100" key={index}>
                                    <td className="fs-16">
                                      <div className="text-left">
                                        {transaction.therapists}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-left">
                                        {transaction.custName}
                                      </div>
                                    </td>
                                    {/* <td className="fs-16">
                                    <div className="text-left  text-lightblue fw-700">
                                      <button
                                        className="border-0 bg-white"
                                        onClick={() =>
                                          this.handleInvoiceRef(
                                            transaction.sa_transacno
                                          )
                                        }
                                      >
                                        {" "}
                                        {transaction.invoiceRef}
                                      </button>
                                    </div>
                                  </td> */}
                                    <td className="fs-16">
                                      <div className="text-left  ">
                                        {transaction.numTherapists}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-left  ">
                                        {transaction.invoiceDate}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center">
                                        {transaction.invoiceRef}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center ">
                                        {transaction.usageRef}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center  ">
                                        {transaction.itemName}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center ">
                                        {transaction.unitValue}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center ">
                                        {transaction.share_amt}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center ">
                                        {transaction.SerPt}
                                      </div>
                                    </td>
                                    <td className="fs-16">
                                      <div className="text-center ">
                                        {transaction.duration}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                              <div className="table-responsive">
                                <table className="table mb-0">
                                  <tbody>
                                    <tr className="text-center">
                                      <td className="fw-700">TOTAL</td>

                                      <td colSpan={7}></td>

                                      <td className="fw-700">Cash Total</td>
                                      <td className="fw-700 px-3 ">
                                        {" "}
                                        {ReportTable.reduce(
                                          (acc, curr) =>
                                            acc + parseFloat(curr.amt),
                                          0
                                        )}
                                      </td>
                                      <td className="fw-700 px-3">
                                        {ReportTable.reduce(
                                          (acc, curr) =>
                                            acc + parseFloat(curr.taxes),
                                          0
                                        )}
                                      </td>
                                      <td className="fw-700 px-3">
                                        {" "}
                                        {ReportTable.reduce(
                                          (acc, curr) =>
                                            acc + parseFloat(curr.BankCharges),
                                          0
                                        )}
                                      </td>
                                      <td className="fw-700 px-3">
                                        {" "}
                                        {ReportTable.reduce(
                                          (acc, curr) =>
                                            acc + parseFloat(curr.total),
                                          0
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>{" "}
                          </NormalTable>
                          <div className="col-md-6 mt-5 text-right"> </div>
                        </>
                      );
                    }
                  )}
                </div>
                {console.log(ReportTable, "ReportTable")}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  //   selectedid: state.consultation.SelectedId,
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getCommonApi, commonCreateApi }, dispatch);
};

export const PrintTreatmentReports = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(PrintTreatmentReportsClass)
);
